<template>
  <div class="intro-banner">
    <div class="banner-img"></div>
  </div>
</template>
